import * as React from 'react';
import { Button, Card } from 'react-bootstrap';
import { LivestreamSession } from 'cb-model';
import { useCacheRecord } from 'gossamer-front-end';
import classes from './JoinLivestreamCard.module.css';

interface JoinLivestreamCardProps {
  livestreamSessionId: string;
  eventStartAt: string | null; // Assuming you have access to the event's start time
}

export const JoinLivestreamCard = (props: JoinLivestreamCardProps): React.JSX.Element => {
  const livestreamRecord = useCacheRecord(LivestreamSession, props.livestreamSessionId);
  const [tick, setTick] = React.useState(0);

  const hasLivestream = Boolean(props.livestreamSessionId) && !!livestreamRecord.data;
  const isLivestreamOnline = hasLivestream && livestreamRecord.data?.status === 'LIVE';
  const eventStartTime = props.eventStartAt ? new Date(props.eventStartAt).getTime() : null;
  const canJoinLivestreamBeforeStart = eventStartTime ? eventStartTime - Date.now() <= 30 * 60 * 1000 : false;
  const canJoinLivestream = !!props.livestreamSessionId && (isLivestreamOnline || canJoinLivestreamBeforeStart);

  React.useEffect(() => {
    if (!eventStartTime) return;
    const nextRefreshAt = eventStartTime - 30 * 60 * 1000;

    if (nextRefreshAt <= Date.now()) return;

    const timeout = window.setTimeout(() => {
      setTick((current) => current + 1);
    }, nextRefreshAt - Date.now());

    return () => window.clearTimeout(timeout);
  }, [eventStartTime, tick]);

  return (
    <Card>
      <Card.Header>Livestream</Card.Header>
      <Card.Body>
        {canJoinLivestream && (
          <div className={classes.PlayButton}>
            <Button size="sm" href={`/view/${props.livestreamSessionId}`}>
              <img src="/assets/icons/play.svg" alt="play icon" />
              &nbsp;Join Livestream
            </Button>
          </div>
        )}
        {!canJoinLivestream && <p>You can join the livestream up to 30 minutes before its scheduled start time.</p>}
      </Card.Body>
    </Card>
  );
};
